import { Route } from 'react-router-dom'
import { ID } from '../utils'
import ResidentCommunicationRecordsScreen from 'screens/Residents/screens/ResidentCommunicationRecordsScreen/ResidentCommunicationRecordsScreen'

export const healthRecordsRoutes = (communicationRecordsEnabled: boolean) => {
  if (!communicationRecordsEnabled) {
    return null
  }

  return (
    <Route
      path={`${ID}/communication-records`}
      element={<ResidentCommunicationRecordsScreen />}
    />
  )
}
